import jsPDF from "jspdf";
import CropOptions from "../../../../helpers/cropOptions";
import { logo } from "../../../../assets";
import { ConvertCropNameToTableIdPrefix } from "../SummaryHelpers";

const AddHeader = (doc, posY, reportName) => {
    doc.addImage(logo, "PNG", 20, posY - 7.5, 50, 12.5); 
    doc.setFontSize(15);
    doc.setFont('times', "bold");
    doc.text(`IPM Plan report: ${reportName}`, 277, posY, null, null, "right");
}

const checkIssuesSelected = (crop, issue) => {
    let flag = false;

    if (document.getElementById(`${ConvertCropNameToTableIdPrefix(crop)}-${issue}-current-selected`) != null ||
        document.getElementById(`${ConvertCropNameToTableIdPrefix(crop)}-${issue}-future-selected`) != null ||
        document.getElementById(`${ConvertCropNameToTableIdPrefix(crop)}-${issue}-no-selected`) != null) {
        flag = true;
    }
    return flag;
}

const CreateNewPage = (doc, posY, reportName) => {
    doc.addPage('landscape');
    posY = 10;
    AddHeader(doc, 10, reportName);

    return posY;
}

const AddNoControlSelected = (doc, posY) => {
    doc.text("No control measures selected", 12, posY)

    doc.setFontSize(16);
    doc.setFont('times', "bold");
    return posY += 10;
}

const AddNoNotes = (doc, posY) => {
    doc.text("No notes", 12, posY)

    doc.setFontSize(16);
    doc.setFont('times', "bold");
    return posY += 10;
}

const AddTitle = (doc, posY) => {
    doc.addImage(logo, "PNG", 80, posY - 25, 120, 30);
    return posY += 10;
}

const AddPlanInformation = ({ doc, posY, reportName, farmName, surveyYear, userEmail, basisNumber, sbiNumber, county }) => {

    const date = new Date();
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    doc.setFontSize(16);
    doc.setFont('times', "bold");
    doc.text(`IPM Plan report: ${reportName}`, 140, posY, null, null, "center");
    posY += 5;
    doc.line(15, posY, 280, posY);
    posY += 10;
    doc.setFontSize(12);

    const farmNameText = `Farm Name: ${farmName}`;
    const splitFarmName = doc.splitTextToSize(farmNameText, 260);
    doc.text(splitFarmName, 20, posY);
    posY += (splitFarmName.length * 5);
    posY += 5;

    if (sbiNumber) {
        doc.text(`SBI Number: ${sbiNumber}`, 20, posY)
        posY += 10;
    }

    if (county) {
        doc.text(`County: ${county}`, 20, posY)
        posY += 10;
    }

    doc.text(`Summary Year: ${surveyYear}`, 20, posY)
    posY += 10;

    doc.text(`Plan completed by: ${userEmail}`, 20, posY);
    posY += 10;
    if (basisNumber) {
        doc.text(`Basis registration number: ${basisNumber}`, 20, posY);
    }
    else {
        doc.text(`Basis registration number: _______________`, 20, posY);
    }
    posY += 10;
    doc.text(`Report generated on: ${day}/${month}/${year}`, 20, posY);
    posY += 5;
    doc.line(15, posY, 280, posY);
    posY += 10;

    return posY;
}

const AddDisclaimer = (doc, posY) => {

    doc.setFontSize(10);

    var text = "The IPM Planning Tool provides access to guidance on integrated pest management (IPM) in outdoor crops and enables users to record current, and planned, IPM actions.The IPM Planning Tool Host has no economic responsibility whatsoever for losses, damages or inconveniences arising out of the use of or inability to use this service.";
    doc.text(text, 150, posY, { maxWidth: 180, align: "center" });
    posY += 15;

    return posY;
}

const AddLogoFooter = (doc) => {
    doc.addImage("/images/logos/adas.png", "JPEG", 50, 190, 15, 15);
    doc.addImage("/images/logos/sruc.png", "JPEG", 65, 190, 25, 15);
    doc.addImage("/images/logos/ahdb.jpg", "JPEG", 85, 190, 25, 15);
    doc.addImage("/images/logos/nfu.jpg", "JPEG", 110, 190, 25, 15);
    doc.addImage("/images/logos/defra.jpg", "JPEG", 138, 190, 25, 15);
    doc.addImage("/images/logos/pgro.jpg", "JPEG", 165, 190, 15, 15);
    doc.addImage("/images/logos/bbro.jpg", "JPEG", 185, 190, 25, 15);
    doc.addImage("/images/logos/vi_ipm.png", "JPEG", 215, 190, 25, 15);
}

const AddIPMAdvicePage = (doc, posY, reportName) => {
    posY = CreateNewPage(doc, posY, reportName);
    posY += 10;

    doc.setFontSize(20);
    doc.setFont('times', "bold");
    doc.text(`IPM advice / information`, 140, posY, null, null, "center");
    posY += 15;

    doc.setFontSize(11);
    doc.setFont('helvetica', "normal");

    const introText = "Integrated Pest Management (IPM) is an approach to controlling diseases, invertebrate pests and weeds (referred to as 'pests' for the remainder of these guidance notes) by integrating pest prevention, monitoring and control strategies.";
    const introLines = doc.splitTextToSize(introText, 260);
    doc.text(introLines, 20, posY);
    posY += (introLines.length * 5) + 10;

    const summaryText = "IPM can be summarised under the headings: Prevent, Detect and Control:";
    doc.text(summaryText, 20, posY);
    posY += 10;

    // Prevent section
    doc.setFont('helvetica', "bold");
    doc.text("• Prevent:", 25, posY);
    doc.setFont('helvetica', "normal");
    const preventText = "Good management of any pest, weed or disease begins with prevention, starting before the crop is sown or the season begins. The first step in prevention is assessing the risk based on a knowledge of its likely occurrence. With this risk assessment, we can use improved hygiene and biosecurity measures, as well as using cultural and genetic approaches (such as resistant varieties) to reduce the risk/incidence of a pest, weed or disease outbreak.";
    const preventLines = doc.splitTextToSize(preventText, 245);
    doc.text(preventLines, 30, posY + 5);
    posY += (preventLines.length * 5) + 10;

    // Detect section
    doc.setFont('helvetica', "bold");
    doc.text("• Detect:", 25, posY);
    doc.setFont('helvetica', "normal");
    const detectText = "Once the cropping season is underway, monitoring is critical, and alongside crop walking the use of smart tools for sensing and predicting pest presence and abundance can improve responsiveness to an emerging threat. With this knowledge, an informed decision can be made about the need to control a pest, weed or disease occurrence.";
    const detectLines = doc.splitTextToSize(detectText, 245);
    doc.text(detectLines, 30, posY + 5);
    posY += (detectLines.length * 5) + 10;

    // Control section
    doc.setFont('helvetica', "bold");
    doc.text("• Control:", 25, posY);
    doc.setFont('helvetica', "normal");
    const controlText = "When control is necessary, an integrated toolbox of control options both chemical and non-chemical can be deployed to manage a pest, weed or disease epidemic.";
    const controlLines = doc.splitTextToSize(controlText, 245);
    doc.text(controlLines, 30, posY + 5);
    posY += (controlLines.length * 5) + 10;

    // Check if we need a new page for the remaining text
    if (posY > 140) {
        posY = CreateNewPage(doc, posY, reportName);
        posY += 10;
    }

    const implementText = "By implementing these techniques, this allows the potential for more environmentally sustainable farming and crop production which has the aim of enhancing the environment. An effective IPM programme is important for maintaining crop health and yields, and for improving resilience within the farming business. Regular evaluation based on records of previous use, dosage and effects of pesticides is an essential part of IPM. Keeping a detailed record of issues and numbers observed, type and dosage of chemical used as well as environmental factors such as weather, helps study the effectiveness of crop protection measures.";
    const implementLines = doc.splitTextToSize(implementText, 260);
    doc.text(implementLines, 20, posY);
    posY += (implementLines.length * 5) + 10;

    const reviewText = "Annually reviewing an IPM plan provides the opportunity to track progress, observe trends and identify strategies that proved successful and those that need improvement from previous cropping seasons.";
    const reviewLines = doc.splitTextToSize(reviewText, 260);
    doc.text(reviewLines, 20, posY);
    posY += (reviewLines.length * 5);

    return posY;
}

const AddGeneralPracticesPage = (doc, posY, reportName) => {
    posY = CreateNewPage(doc, posY, reportName);
    posY += 10;

    doc.setFontSize(20);
    doc.setFont('times', "bold");
    doc.text(`General Practices`, 140, posY, null, null, "center");
    posY += 15;

    // Get the general practices accordion element
    const generalPracticesAccordion = document.querySelector('.general-practices-accordion');

    if (!generalPracticesAccordion) {
        doc.setFontSize(12);
        doc.setFont('helvetica', "normal");
        doc.text("No practices selected", 20, posY);
        return posY;
    }

    // Get all practice items (excluding nested card items)
    const practiceItems = generalPracticesAccordion.querySelectorAll('.accordion-body > .vstack > .border.rounded, .accordion-body > .vstack > .card');

    if (practiceItems.length === 0) {
        doc.setFontSize(12);
        doc.setFont('helvetica', "normal");
        doc.text("No practices selected", 20, posY);
        return posY;
    }

    practiceItems.forEach(item => {
        // Check if this is a nested card (Biopesticides or Precision Techniques)
        if (item.classList.contains('card')) {
            // Get the card header title
            const cardHeader = item.querySelector('.card-header');
            if (cardHeader) {
                // Check if we need a new page
                if (posY > 180) {
                    posY = CreateNewPage(doc, posY, reportName);
                    posY += 10;
                }

                doc.setFontSize(12);
                doc.setFont('times', "bold");
                const headerText = cardHeader.textContent.replace(/▲|▼/g, '').trim();
                doc.text(headerText, 20, posY);
                posY += 7;
                doc.setFontSize(11);
                doc.setFont('helvetica', "normal");

                // Get all sub-items within this card
                const subItems = item.querySelectorAll('.card-body .border.rounded');
                subItems.forEach(subItem => {
                    const subQuestion = subItem.querySelector('h6');
                    const subStatus = subItem.querySelector('p:nth-of-type(1)');
                    const subNotes = subItem.querySelector('p:nth-of-type(2)');

                    if (subQuestion && subStatus) {
                        const statusText = subStatus.textContent.replace('Status:', '').trim();

                        // Skip items with N/A status
                        if (statusText === 'N/A') {
                            return;
                        }

                        doc.text(`  • ${subQuestion.textContent.trim()}: ${statusText}`, 25, posY);
                        posY += 5;

                        if (subNotes && subNotes.textContent.includes('Notes:')) {
                            const notesContent = subNotes.querySelector('span')?.textContent.trim() || '';
                            if (notesContent) {
                                const notesText = doc.splitTextToSize(`    Notes: ${notesContent}`, 245);
                                doc.text(notesText, 25, posY);
                                posY += (notesText.length * 5);
                            } else {
                                doc.text("    Notes: No notes", 25, posY);
                                posY += 5;
                            }
                        } else {
                            doc.text("    Notes: No notes", 25, posY);
                            posY += 5;
                        }
                    }
                });
                posY += 5;
            }
        } else {
            // Regular practice item
            const question = item.querySelector('h6');
            const statusPara = item.querySelector('p:nth-of-type(1)');
            const notesPara = item.querySelector('p:nth-of-type(2)');

            if (question && statusPara) {
                // Check if we need a new page
                if (posY > 180) {
                    posY = CreateNewPage(doc, posY, reportName);
                    posY += 10;
                }

                doc.setFontSize(12);
                doc.setFont('times', "bold");
                const questionText = doc.splitTextToSize(question.textContent.trim(), 260);
                doc.text(questionText, 20, posY);
                posY += (questionText.length * 6);

                doc.setFontSize(11);
                doc.setFont('helvetica', "normal");
                const statusText = statusPara.textContent.replace('Status:', '').trim();
                doc.text(`Answer: ${statusText}`, 25, posY);
                posY += 6;

                if (notesPara && notesPara.textContent.includes('Notes:')) {
                    const notesContent = notesPara.querySelector('span')?.textContent.trim() || '';
                    if (notesContent) {
                        const notesText = doc.splitTextToSize(`Notes: ${notesContent}`, 250);
                        doc.text(notesText, 25, posY);
                        posY += (notesText.length * 5);
                    } else {
                        doc.text("Notes: No notes", 25, posY);
                        posY += 5;
                    }
                } else {
                    doc.text("Notes: No notes", 25, posY);
                    posY += 5;
                }
                posY += 8;
            }
        }
    });

    return posY;
}

const AddCroppingSummaryPage = (doc, posY, reportName) => {
    posY = CreateNewPage(doc, posY, reportName);
    posY += 20;
    doc.setFontSize(16);
    doc.text(`Cropping Summary`, 16, posY);
    posY += 5;
    doc.autoTable({ html: "#crop-areas", startY: posY, tableWidth: 'wrap' });
    posY = doc.lastAutoTable.finalY + 10;

    

}

const AddResistanceManagementPage = (doc, posY, reportName) => {
    // Get the resistance management accordion element
    const resistanceAccordion = document.querySelector('.resistance-management-accordion');

    if (!resistanceAccordion) {
        return posY;
    }

    // Create new page for Resistance Management
    posY = CreateNewPage(doc, posY, reportName);
    posY += 10;

    doc.setFontSize(20);
    doc.setFont('times', "bold");
    doc.text(`Resistance Management`, 140, posY, null, null, "center");
    posY += 15;

    // Check if there's a "No resistance management selected" message
    const noResistanceMessages = resistanceAccordion.querySelectorAll('h5');
    const hasNoResistanceMessage = Array.from(noResistanceMessages).some(h5 =>
        h5.textContent.includes('No resistance management selected')
    );

    if (hasNoResistanceMessage) {
        doc.setFontSize(12);
        doc.setFont('helvetica', "normal");
        doc.text("No resistance management selected", 20, posY);
        return posY;
    }

    // Get all sections (Pests, Diseases, Weeds)
    const sections = resistanceAccordion.querySelectorAll('.mb-5');

    if (sections.length === 0) {
        doc.setFontSize(12);
        doc.setFont('helvetica', "normal");
        doc.text("No resistance management selected", 20, posY);
        return posY;
    }

    // Check if there are any tables
    const tables = resistanceAccordion.querySelectorAll('table');
    if (tables.length === 0) {
        doc.setFontSize(12);
        doc.setFont('helvetica', "normal");
        doc.text("No resistance management selected", 20, posY);
        return posY;
    }

    sections.forEach((section, index) => {
        // Get section title (Pests, Diseases, Weeds)
        const sectionTitle = section.querySelector('h4');
        if (!sectionTitle) return;

        // Check if this section has the "No resistance management selected" message
        const sectionNoMessage = section.querySelector('h5');
        if (sectionNoMessage && sectionNoMessage.textContent.includes('No resistance management selected')) {
            return; // Skip this section
        }

        // Check if we need a new page
        if (posY > 170) {
            posY = CreateNewPage(doc, posY, reportName);
            posY += 10;
        }

        doc.setFontSize(16);
        doc.setFont('times', "bold");
        doc.text(sectionTitle.textContent.trim(), 20, posY);
        posY += 10;

        // Get the table
        const table = section.querySelector('table tbody');
        if (!table) return;

        const rows = table.querySelectorAll('tr');

        if (rows.length === 0) {
            doc.setFontSize(11);
            doc.setFont('helvetica', "normal");
            doc.text("No data", 25, posY);
            posY += 8;
            return;
        }

        doc.setFontSize(11);
        doc.setFont('helvetica', "normal");

        rows.forEach(row => {
            const cells = row.querySelectorAll('td');
            if (cells.length >= 2) {
                const question = cells[0].textContent.trim();
                const status = cells[1].textContent.trim();
                const notes = cells.length > 2 ? cells[2].textContent.trim() : '-';

                // Check if we need a new page
                if (posY > 180) {
                    posY = CreateNewPage(doc, posY, reportName);
                    posY += 10;
                }

                // Print question and status
                doc.setFont('helvetica', "bold");
                doc.text(`${question}:`, 25, posY);
                doc.setFont('helvetica', "normal");
                doc.text(status, 80, posY);
                posY += 6;

                // Print notes if not just a dash
                if (notes && notes !== '-') {
                    const notesText = doc.splitTextToSize(`Notes: ${notes}`, 240);
                    doc.text(notesText, 30, posY);
                    posY += (notesText.length * 5);
                } else {
                    doc.text("Notes: No notes", 30, posY);
                    posY += 5;
                }
                posY += 3;
            }
        });

        posY += 5;
    });

    return posY;
}

export const generateReportPDF = ({ reportName, farmName, surveyYear, userEmail, basisNumber, listOfCrops, listOfOtherCrops, sbiNumber, county }) => {
    const allCrops = [...listOfCrops, ...listOfOtherCrops]

    const doc = new jsPDF('landscape');
    let posY = 30;

    posY = AddTitle(doc, posY);
    posY = AddPlanInformation({ doc, posY, reportName, farmName, surveyYear, userEmail, basisNumber, sbiNumber, county });
    posY = AddDisclaimer(doc, posY);
    AddLogoFooter(doc);

    posY = AddIPMAdvicePage(doc, posY, reportName);

    posY = AddCroppingSummaryPage(doc, posY, reportName);

    // Add General Practices page
    posY = AddGeneralPracticesPage(doc, posY, reportName);

    jsPDF.autoTableSetDefaults({});
    posY = CreateNewPage(doc, posY, reportName);

    allCrops.forEach(crop => {
        posY = 10;
        AddHeader(doc, posY, reportName);
        posY += 20;

        doc.setFontSize(20);
        doc.setFont('times', "bold");
        let selectedCrop = CropOptions.find((option) => option.cropType.toLowerCase() === crop.toLowerCase())
        if (selectedCrop === undefined)
            selectedCrop = { title: crop.charAt(0).toUpperCase() + crop.slice(1), cropType: crop.toLowerCase(), isOther: true }
        doc.text(`${selectedCrop.title}`, 140, posY, null, null, "center");

        const issues = ['pests', 'diseases', 'weeds'];
        issues.forEach(issue => {
            if (issue === 'weeds' && (crop !== 'apple' && crop !== 'improvedgrassland')) {
                return;
            }
            if (checkIssuesSelected(crop, issue)) {
                posY += 10;
                doc.setFontSize(16);
                doc.text(`${selectedCrop.title.toUpperCase()} - ${issue.toUpperCase()}`, 16, posY);
                posY += 5;
                doc.autoTable({ html: `#${crop.toLowerCase()}-${issue}-no-selected`, startY: posY });
                posY = doc.lastAutoTable.finalY + 10;

                doc.text(`Use in current cropping season`, 12, posY);
                posY += 5;
                if (document.getElementById(`${ConvertCropNameToTableIdPrefix(crop)}-${issue}-current-selected`) != null) {
                    doc.autoTable({ html: `#${ConvertCropNameToTableIdPrefix(crop)}-${issue}-current-selected`, startY: posY });
                    posY = doc.lastAutoTable.finalY + 10;
                } else {
                    posY += 5;
                    doc.setFontSize(10);
                    doc.setFont('helvetica', 'normal');
                    posY = AddNoControlSelected(doc, posY);
                }

                doc.text(`Intend to use in future seasons`, 12, posY);
                posY += 5;
                if (document.getElementById(`${ConvertCropNameToTableIdPrefix(crop)}-${issue}-future-selected`) != null) {
                    doc.autoTable({ html: `#${ConvertCropNameToTableIdPrefix(crop)}-${issue}-future-selected`, startY: posY });
                    posY = doc.lastAutoTable.finalY + 10;
                } else {
                    posY += 5;
                    doc.setFontSize(10);
                    posY = AddNoControlSelected(doc, posY);
                }

            } else {
                posY += 10;
                doc.setFontSize(16);
                doc.text(`${selectedCrop.title.toUpperCase()} - ${issue.toUpperCase()}`, 16, posY);
                posY += 10;
                doc.setFontSize(16);
                doc.setFont('helvetica', 'normal');
                doc.text("No issues selected", 12, posY)
            }

            posY = CreateNewPage(doc, posY, reportName);
        })
    });

    posY = 10;
    posY += 20;
    doc.setFontSize(20);
    doc.text("Weeds", 12, posY)

    const weedTables = [
        { TableId: "weed-weeds-current-selected", TableName: "Use in current cropping season" },
        { TableId: "weed-weeds-future-selected", TableName: "Intend to use in future seasons" },
        { TableId: "weed-weeds-notes", TableName: "Control measure notes" }
    ];

    weedTables.forEach(weedTable => {
        AddWeedTableName(weedTable);
        posY += 10;
        if (document.getElementById(weedTable.TableId) != null) {
            doc.autoTable({ html: `#${weedTable.TableId}`, startY: posY });
            posY = doc.lastAutoTable.finalY + 10;
        } else if (weedTable.TableId !== "weed-weeds-no-selected") {
            posY = AddNoControlSelected(doc, posY);
        }
    })

    function AddWeedTableName(weedTable) {
        posY += 10;
        doc.setFontSize(16)
        doc.text(weedTable.TableName, 12, posY)
    }

    // Add Resistance Management page
    posY = AddResistanceManagementPage(doc, posY, reportName);

    doc.save(`${reportName}.pdf`);
    return doc.output('blob');
}